
  import React, { Component } from "react";
  import { Link } from "react-router-dom";
  import { Segment, List, Input, Form, Header,  Checkbox, Select, Divider} from 'semantic-ui-react'
  import { invokeApig } from "../libs/awsLib";
  import { defaultJSONObject } from "../libs/sharedFunctions";
  import DecisionRules from "./DecisionRules"
import { strict } from "assert";

  export default class JSONDataEntry extends Component {

      constructor(props) {
        super(props);
        
        var data=this.props.data;
        if (this.props.jsonformat.type==='array' && data==null)
          data=[]
        else if (this.props.jsonformat.type==='object' && data==null)
          data={}

        this.state = {
            data: data
        };
        // this.updateAddress=this.updateAddress.bind(this);
      }   

      loadLookups=(jsonformat)=>
      {
        //if this is an object with fields then load any associated lookups 
        if ('fields' in jsonformat)
            Object.keys(jsonformat.fields).filter(fieldname=>{return ('lookup' in jsonformat.fields[fieldname])}).map(fieldname=>
            {
                this.loadLookup(jsonformat.fields[fieldname].lookup);
            })
        //if this is a field with a lookup then load it
        //run recursively for any subobjects
        if ('lookup' in jsonformat)
            this.loadLookup(jsonformat.lookup);
        if ('keylookup' in jsonformat)
            this.loadLookup(jsonformat.keylookup);            
        if ('arrayof' in jsonformat)
            this.loadLookups(jsonformat.arrayof);
        if ('dictionaryof' in jsonformat)
            this.loadLookups(jsonformat.dictionaryof);            
        if ('subobjects' in jsonformat)
            Object.keys(jsonformat.subobjects).map(subobjectname=>
                {
                    this.loadLookups(jsonformat.subobjects[subobjectname]);
                })




            

      }  
      loadLookup = (lookupname) => {
        if (!('lookup_'+lookupname in this.state))
            invokeApig({path: "/lookups/"+lookupname, method: "GET",  body: null}).then(result=>{this.setState({['lookup_'+lookupname]: result.data})})
      }
      
    componentDidMount()
    {
        this.loadLookups(this.props.jsonformat)
    }

    componentWillReceiveProps(nextProps)
    {
      var data=nextProps.data;
      if (this.props.jsonformat.type==='array' && data==null)
        data=[]
      else if (this.props.jsonformat.type==='object' && data==null)
        data={}

        this.setState({data: data})
    }


    render() {
      
      const updateJSONField=(key, fieldname, value)=>
      {
        //console.log(key, fieldname, value);
        // var object=Object.assign({}, this.state.data);
        var object=this.state.data;

        if (fieldname==='')
        {
            //must be an array of fields
            const arrayKey=key.split(':').slice(0,-1).join(':')
            const arrayIndex=parseInt(key.split(':').slice(-1))
            var parentArray=getObjectByKey(object, arrayKey);
            //console.log(arrayKey, arrayIndex, parentArray)
            parentArray[arrayIndex]=value
        }    
        else
        {
            var subobject=getObjectByKey(object, key);
            if(!subobject)
                subobject={};
            subobject[fieldname]=value;
        }
            
        // selectedObject[fieldname]=value;
        this.setState({data: object});
        this.props.onDataChange(object)
      }

      const addSubArray=(parentKey, subobjectdef)=>
      {
        var object=this.state.data;
        var subobject=getObjectByKey(object, parentKey);
        if (subobjectdef.type==='object')
            subobject.push({})
        else
            subobject.push('')
        this.setState({data: object});
        this.props.onDataChange(object)
      }
      const removeArrayItem=(parentKey, index)=>
      {
        var object=this.state.data;
        var subobject=getObjectByKey(object, parentKey);
        subobject.splice(index, 1);
        this.setState({data: object});
        this.props.onDataChange(object)
      }
      const setDictionaryKey=(parentKey, dictionaryKey, inDictionary, newValue={})=>
      {
        var object=this.state.data;
        var subobject=getObjectByKey(object, parentKey);
        //console.log(subobject, parentKey, dictionaryKey, inDictionary, newValue)
        if (inDictionary)
        {
          if (!(dictionaryKey in subobject))
            subobject[dictionaryKey]=newValue
        }            
        else
        if (dictionaryKey in subobject)
        {console.log('delete')
        delete subobject[dictionaryKey]
      }
          

        this.setState({data: object});
        this.props.onDataChange(object)
      }
      const removeSubObject=(key)=>
      {
        var object=this.state.data;
        const parseKey=key.split('|');
        const parentKey=parseKey.slice(0,-1).join('|');
        const objectName=parseKey.slice(-1)
        var parentObject=getObjectByKey(object, parentKey);
        delete parentObject[objectName]
        this.setState({data: object});
        this.props.onDataChange(object)
      }
      const addSubObject=(key, jsonformat)=>
      {
        var object=this.state.data;
        const parseKey=key.split('|');
        const parentKey=parseKey.slice(0,-1).join('|');
        const objectName=parseKey.slice(-1);
        var parentObject=getObjectByKey(object, parentKey);
        parentObject[objectName]=defaultJSONObject(jsonformat);
        this.setState({data: object});
        this.props.onDataChange(object)
      }
      const getObjectByKey=(object, key)=>

      {
        //console.log(key, JSON.stringify(object))
      return key.split('|').reduce((subobject, subkey)=>
          {
            // console.log(subkey, JSON.stringify(subobject))
              if (subkey==='root')
              return subobject
              else if (subkey.startsWith('root:'))
              {
                    const parseobjectkey=subkey.split(':');
                    return subobject[parseInt(parseobjectkey[1])]
              }
            else 
            {
              if (subkey.includes(':'))  
              {
                const parseobjectkey=subkey.split(':');
                return subobject[parseobjectkey[0]][parseInt(parseobjectkey[1])]
              }
              else 
              {
                if (!(subkey in subobject))
                  subobject[subkey]={};
                return subobject[subkey]
              }

            }
          }, object)
          // return subobject;
      }

       //   const removeEntity=(key)=>
    //   {
    //     if (key===this.props.toplevelentity)
    //       //top level - remove entire object
    //       this.props.onRemove(this.props.objectid)
    //     else
    //     {
    //       //remove subentity
    //       var object=Object.assign({}, this.state.object);
    //       const parentKey=key.split('|').slice(0,-1).join('|')
    //       var parentObject=getObjectByKey(object, parentKey)
    //       const removeKey= key.split('|').slice(-1)[0]
    //       const parseRemoveKey=removeKey.split(':');
    //       const removeArray=parentObject[parseRemoveKey[0]];
    //       const removeIndex=parseInt(parseRemoveKey[1]);
    //       console.log(removeArray, removeIndex)
    //       removeArray.splice(removeIndex, 1);
    //       console.log(removeArray)
    //       this.setState({object: object});
    //       this.props.onDataChange(this.props.objectid, object)
    //     }
    //   }      

      const renderField=(fieldname, field, value, key)=>
      {
        var renderfield;
        const fieldkey=key+'|'+fieldname


        if (field.type==='array')
        {
          return renderObject(field, value, key)
        }
        if ('lookup' in field)
        {
          const lookupvalues=this.state['lookup_'+field.lookup]
          renderfield=<Select key={fieldkey} placeholder={field.label} className="inputfield" disabled={!this.props.editmode} options={lookupvalues} value={value} onChange={(event, data)=>{updateJSONField(key, fieldname, data.value)}}/>
        }
        else if ('lookupvalues' in field)
        {
          const lookupvalues=Object.keys(field.lookupvalues).map(key=>{return {key: key, text: field.lookupvalues[key], value: key}})
          renderfield=<Select key={fieldkey} placeholder={field.label} className="inputfield" disabled={!this.props.editmode} options={lookupvalues} value={value} onChange={(event, data)=>{updateJSONField(key, fieldname, data.value)}}/>
        }
        else
        {
          if (field.type==='varchar')
            renderfield=<Input key={fieldkey} placeholder={field.label} className="inputfield" disabled={!this.props.editmode} type='text' maxLength={field.length} value={value} onChange={(event, data)=>{updateJSONField(key, fieldname, data.value)}}/> 
          else if (field.type==='int')
            renderfield=<Input key={fieldkey} placeholder={field.label} type='number' step="1" disabled={!this.props.editmode} maxLength={field.length} className="inputfield" maxLength={field.length} value={value} onChange={(event, data)=>{updateJSONField(key, fieldname, parseInt(data.value))}}/> 
          else if (field.type==='decimal')
            renderfield=<Input key={fieldkey} placeholder={field.label} type='number' disabled={!this.props.editmode} step={Math.pow(10, -field.scale)} maxLength={field.precision} className="inputfield" maxLength={field.length} value={value} onChange={(event, data)=>{updateJSONField(key, fieldname, parseFloat(data.value))}}/> 
          else if (field.type==='date')
            renderfield=<Input key={fieldkey} placeholder={field.label} type='date' disabled={!this.props.editmode} className="inputfield" maxLength={field.length} value={value} onChange={(event, data)=>{updateJSONField(key, fieldname, data.value)}}/> 
          else if (field.type==='datetime')
            renderfield=<Input key={fieldkey} placeholder={field.label} type='datetime-local' disabled={!this.props.editmode} className="inputfield" maxLength={field.length} value={value} onChange={(event, data)=>{updateJSONField(key, fieldname, data.value+':00')}}/> 
            else if (field.type==='time')
            renderfield=<Input key={fieldkey} placeholder={field.label} type='time' disabled={!this.props.editmode} className="inputfield" maxLength={field.length} value={value} onChange={(event, data)=>{updateJSONField(key, fieldname, data.value+':00')}}/> 

          else if (field.type==='bit')
            if (field.toggle)
            renderfield=<Form.Field inline><Checkbox toggle inverted={this.props.darkmode} key={fieldkey} disabled={!this.props.editmode} className="inputfield" checked={value} onChange={(event, data)=>{updateJSONField(key, fieldname, data.checked)}}/><label style={{color: this.props.darkmode ? "white": "black"}}>{field.label}</label></Form.Field>
            else
            renderfield=<Form.Field inline><Checkbox inverted={this.props.darkmode} key={fieldkey} disabled={!this.props.editmode} className="inputfield" checked={value} onChange={(event, data)=>{updateJSONField(key, fieldname, data.checked)}}/><label style={{color: this.props.darkmode ? "white": "black"}}>{field.label}</label></Form.Field>
          }
          if (renderfield)
          {
            if (field.type!=='bit')
            return <Form.Field required={!field.nullable}>
              <label>{field.label}</label>
              {renderfield}
            </Form.Field>
            else
              return renderfield
          }
          
      }
    


      const renderObject=(jsondef, data, key, subobjectname=null)=>
      {
            if (jsondef.type==='array' && Array.isArray(data))
            {
              
                return <List>
                <Form.Field><label>{jsondef.title+'  '}{this.props.editmode && <a onClick={()=>{addSubArray(key, jsondef.arrayof)}}>add</a>}</label></Form.Field>
                {data.map((listitem, i)=>
                {return <List.Item>
                    <Form.Field><label>{jsondef.itemtitle+'  '+(i+1)+' '}{this.props.editmode && <a onClick={()=>{removeArrayItem(key, i)}}>delete</a>}</label></Form.Field>
                    <List.Content>
                    {jsondef.arrayof.type==='object' ? renderObject(jsondef.arrayof, listitem, key+':'+i) : renderField("", jsondef.arrayof, listitem, key+':'+i) }
                    <Divider/>
                    </List.Content>
                </List.Item>
                })}
                </List>
            }
            else if (jsondef.type==='object')
            {
                return <Form inverted={this.props.darkmode}>
                    {subobjectname && <Form.Field><label>{subobjectname+'  '}</label>{data ? this.props.editmode && <a onClick={()=>{removeSubObject(key)}}>delete</a> : this.props.editmode && <a onClick={()=>{addSubObject(key, jsondef)}}>add</a> }</Form.Field>}
                    <Segment>
                {'fields' in jsondef && Object.keys(jsondef.fields).map(fieldname=>
                {
                    const field=jsondef.fields[fieldname]
                    var value=null;
                    var showField=true;
                    if (data && fieldname in data)
                    {
                        value=data[fieldname]
                    }

                    if (field.conditionalon)
                      if ("conditionalvalue" in field)
                      {
                        console.log(field, data)
                        if (Array.isArray(field.conditionalvalue))
                          showField=(field.conditionalvalue.indexOf(data[field.conditionalon])>-1);
                        else
                          showField=(data[field.conditionalon]===field.conditionalvalue);
                        console.log(field.conditionalon, data[field.conditionalon], field.conditionalvalue, showField)
                      }
                       
                      else
                        if (!data[field.conditionalon])
                          showField=false;
                  
                    if (showField)
                      return renderField(fieldname, field, value, key)

                })}
                {'subobjects' in jsondef && Object.keys(jsondef.subobjects).map(subobjectname=>
                {
                    var value=null;
                    var showObject=true;

                    const subobject=jsondef.subobjects[subobjectname];

                    if (subobject.conditionalon)
                    if ("conditionalvalue" in subobject)
                    {
                      if (Array.isArray(subobject.conditionalvalue))
                        showObject=(subobject.conditionalvalue.indexOf(data[subobject.conditionalon])>-1);
                      else
                        showObject=(data[subobject.conditionalon]===subobject.conditionalvalue);
                      
                        console.log(subobject.conditionalon, data, data[subobject.conditionalon], subobject.conditionalvalue, showObject)
                    }
                    else
                      if (!data[subobject.conditionalon])
                      showObject=false;

                    if (showObject)
                    {
                      if (data)
                        if (subobjectname in data)
                        {
                            value=data[subobjectname]
                        }
                       
                      return renderObject(subobject, value, key+'|'+subobjectname, subobject.label)
  
                    }
                    

                   

                })}                
                    </Segment></Form>
                
            }
            if (jsondef.type==='dictionary')
            {
              var newObject={};
              if ('newobjecttemplate' in jsondef)
                newObject=jsondef.newobjecttemplate

              if ('keylookup' in jsondef)
              {
              var keyValues={};
              if ('lookup_'+jsondef.keylookup in this.state)
                keyValues=this.state['lookup_'+jsondef.keylookup]

              return <List>
               <Form.Field><label>{jsondef.title}</label></Form.Field>

                {Object.keys(keyValues).map((dictionaryKey, i)=>
                {
                 
                  return <List.Item>
                    <Form.Field><label style={{color: this.props.darkmode ? "white": "black"}}><Checkbox toggle disabled={!this.props.editmode} label={dictionaryKey} checked={dictionaryKey in data} onChange={(event, data)=>{setDictionaryKey(key, dictionaryKey, data.checked, newObject)}}/></label></Form.Field>
                    <List.Content>
                    <Divider/>  
                    {dictionaryKey in data && (jsondef.dictionaryof.type==='object' || jsondef.dictionaryof.type==='decisionrules' ? renderObject(jsondef.dictionaryof, data[dictionaryKey], key+'|'+dictionaryKey) : renderField("", jsondef.dictionaryof, data[dictionaryKey], key+'|'+dictionaryKey))}
                    <Divider/>
                    </List.Content>
                </List.Item>
                })}
                </List>
            }
            else
            {
            return <List>
            <Form.Field><label>{jsondef.title}</label></Form.Field>
            {Object.keys(data).map((dictionaryKey, i)=>
            {
              return <List.Item>
                <Form.Field><label>{dictionaryKey}<a onClick={()=>{setDictionaryKey(key, dictionaryKey, false)}}>  delete</a></label></Form.Field>
                <List.Content>
                <Divider/>  
                {(jsondef.dictionaryof.type==='object' || jsondef.dictionaryof.type==='decisionrules' || jsondef.dictionaryof.type==='array' ? renderObject(jsondef.dictionaryof, data[dictionaryKey], key+'|'+dictionaryKey) : renderField("", jsondef.dictionaryof, data[dictionaryKey], key+'|'+dictionaryKey))}
                <Divider/>
                </List.Content>
            </List.Item>
            })}
            <Form.Field><label>New Key{'  '}
            <Input value={this.state.newkey} onChange={(event, data)=>{this.setState({newkey: data.value})}}/>
            <a onClick={()=>{setDictionaryKey(key, this.state.newkey, true, newObject)}}>  add</a>
            </label></Form.Field>

            </List>
            }
          }

            if (jsondef.type==='decisionrules')
            {
              
              // return <DecisionRules data={data} rulefields={jsondef.rulefields} valuefields={{status: {description: 'Authorisation Status', type: 'numeric', values: [{key: 1, text: 'Passed', value: 1}, {key: 2, text: 'Failed', value: 2}, {key: 3, text: 'Referred', value: 3}]}, reason: {description: 'Reason', type: 'text', length: 100}}}/>
              // return <DecisionRules data={data} rulefields={jsondef.rulefields} valuefields={jsondef.valuefields}/>
              var parseKey=key.split('|');
              var fieldName=parseKey.pop();
              var objKey=parseKey.join('|');
              return <DecisionRules data={data} editmode={this.props.editmode} label={jsondef.label} onDataChange={(data=>{updateJSONField(objKey, fieldName, data)})} rulefields={jsondef.rulefields} valuefields={jsondef.valuefields} darkmode={this.props.darkmode}/>

            }


      }


      return (
        <div>
            {renderObject(this.props.jsonformat, this.state.data, 'root')}
        </div>
      );
    }
  }